const utils = require('frontend-controller/lib/utils')

module.exports = {
	events: {
		click: function(event){
			event.preventDefault();
			event.stopImmediatePropagation();
			utils.performButtonAction(event);
		}
	},

	methods: {

		showEdit: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var blackListedProductIDs = [];
			this.closest('base_form_form', function(form){
				var productID = ((form.resourceData.data || {}).attributes || {})[(form.resourceData.data || {}).primaryKey || 'id']
				if(productID){
					blackListedProductIDs.push(productID);
				}
			});
			this.performAndStoreAction(
				'showEdit_subProducts_inEffect',
				this.prepareAction(
					'showEdit_subProducts',
					undefined,
					{
						selectedRowIDs: this.model.dataJSON || [],
						blackListedProductIDs
					}
				)
			)
		}
	},

	hooks: {
		async onDecision($element, options){
			switch(options.decisionType){
				case 'submit':
					this.model.dataJSON = []

					let table, parent
					options.decisionComponent.find('templates_ttgShop_products_table_table', c => table = c)
					this.parent(c => parent = c)

					if(table && table.config.isSelectionTarget){
						this.model.dataJSON = table.getSelectedRowIDs()
					}
					if(parent){
						parent.fieldToModel(this.model.fieldCode, this.model.dataJSON)
						parent.refresh()
					}
					break

				case 'cancel':
					// do nothing
					break
			}

			await options.decisionComponent.hide()
		},

		onChildChanged: function($element, options){
			this.triggerClosest('onChildChanged', {
				fieldCode: 	this.model.fieldCode,
				value: 		options.value
			})
		}
	}
};